import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
import { ShieldCheckIcon } from 'lucide-react';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="w-full bg-[#111D35] text-white/50" aria-label="Pie de página" data-id="element-39">
        <div className="max-w-3xl mx-auto px-5 py-8" data-id="element-40">
          <div className="flex flex-col items-center gap-4" data-id="element-41">
            {/* Brand */}
            <div className="flex items-center gap-2" data-id="element-42">
              <ShieldCheckIcon className="w-4 h-4 text-white/30" aria-hidden="true" data-id="element-43" />
              <span className="text-sm text-white/40 font-medium" data-id="element-44">
                SOS Muela
              </span>
            </div>

            {/* Legal Links */}
            <div className="flex items-center gap-6" data-id="element-45">
              <button onClick={() => setPrivacyOpen(true)} className="text-sm text-white/50 hover:text-white/80 underline underline-offset-2 transition-colors focus:outline-none focus:text-white/80" data-id="element-46">
                Política de Privacidad
              </button>
              <span className="text-white/20" aria-hidden="true" data-id="element-47">
                |
              </span>
              <button onClick={() => setTermsOpen(true)} className="text-sm text-white/50 hover:text-white/80 underline underline-offset-2 transition-colors focus:outline-none focus:text-white/80" data-id="element-48">
                Términos de Servicio
              </button>
            </div>

            {/* Copyright */}
            <p className="text-xs text-white/30" data-id="element-49">
              © {new Date().getFullYear()} SOS Muela. Todos los derechos
              reservados.
            </p>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-50">
        <p className="font-semibold text-[#1B2A4A]" data-id="element-51">
          Última actualización: febrero 2026
        </p>

        <p data-id="element-52">
          En SOS Muela, respetamos tu privacidad. Esta política describe qué
          información recopilamos, cómo la usamos y cómo la protegemos cuando
          compras o usas nuestro producto digital.
        </p>

        <h3 className="font-bold text-[#1B2A4A] text-lg mt-2" data-id="element-53">
          1. Información que recopilamos
        </h3>
        <p data-id="element-54">
          Al realizar tu compra, nuestro procesador de pagos recopila la
          información necesaria para completar la transacción, como tu nombre,
          dirección de correo electrónico y datos de pago. Nosotros no
          almacenamos datos de tarjetas de crédito ni información financiera
          directamente.
        </p>

        <h3 className="font-bold text-[#1B2A4A] text-lg mt-2" data-id="element-55">
          2. Uso de la información
        </h3>
        <p data-id="element-56">Usamos tu correo electrónico únicamente para:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-57">
          <li data-id="element-58">Enviarte el enlace de descarga de tu producto.</li>
          <li data-id="element-59">Comunicarnos contigo si hay un problema con tu pedido.</li>
        </ul>
        <p data-id="element-60">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros con fines de marketing.
        </p>

        <h3 className="font-bold text-[#1B2A4A] text-lg mt-2" data-id="element-61">
          3. Cookies y seguimiento
        </h3>
        <p data-id="element-62">
          Nuestro sitio puede usar cookies básicas para funcionalidad y análisis
          anónimo de tráfico. No usamos cookies para rastrearte en otros sitios
          web.
        </p>

        <h3 className="font-bold text-[#1B2A4A] text-lg mt-2" data-id="element-63">4. Seguridad</h3>
        <p data-id="element-64">
          Utilizamos conexiones cifradas (SSL/TLS) y procesadores de pago
          certificados para proteger tu información durante la transacción.
        </p>

        <h3 className="font-bold text-[#1B2A4A] text-lg mt-2" data-id="element-65">
          5. Tus derechos
        </h3>
        <p data-id="element-66">
          Puedes solicitar la eliminación de tus datos personales en cualquier
          momento. También puedes solicitar acceso a la información que tenemos
          sobre ti.
        </p>

        <h3 className="font-bold text-[#1B2A4A] text-lg mt-2" data-id="element-67">
          6. Cambios a esta política
        </h3>
        <p data-id="element-68">
          Nos reservamos el derecho de actualizar esta política. Cualquier
          cambio será publicado en esta página con la fecha de actualización
          correspondiente.
        </p>
      </LegalModal>

      {/* Terms of Service Modal */}
      <LegalModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos de Servicio" data-id="element-69">
        <p className="font-semibold text-[#1B2A4A]" data-id="element-70">
          Última actualización: febrero 2026
        </p>

        <p data-id="element-71">
          Al comprar y descargar SOS Muela — Protocolo de 48 Horas, aceptas los
          siguientes términos y condiciones.
        </p>

        <h3 className="font-bold text-[#1B2A4A] text-lg mt-2" data-id="element-72">
          1. Naturaleza del producto
        </h3>
        <p data-id="element-73">
          SOS Muela es un recurso educativo e informativo en formato PDF
          digital.{' '}
          <strong data-id="element-74">
            No es un servicio médico, no proporciona diagnósticos y no sustituye
            la atención de un profesional de salud dental.
          </strong>{' '}
          Si tienes una emergencia médica, llama al 911 o acude a la sala de
          emergencias más cercana.
        </p>

        <h3 className="font-bold text-[#1B2A4A] text-lg mt-2" data-id="element-75">
          2. Entrega del producto
        </h3>
        <p data-id="element-76">
          El producto se entrega como descarga digital inmediata después de
          completar el pago. Recibirás acceso al archivo PDF a través de un
          enlace de descarga.
        </p>

        <h3 className="font-bold text-[#1B2A4A] text-lg mt-2" data-id="element-77">
          3. Política de reembolso
        </h3>
        <p data-id="element-78">
          Debido a la naturaleza digital del producto y su entrega inmediata,
          todas las ventas son finales. Si experimentas problemas técnicos con
          la descarga, haremos todo lo posible por ayudarte a obtener tu
          archivo.
        </p>

        <h3 className="font-bold text-[#1B2A4A] text-lg mt-2" data-id="element-79">
          4. Uso permitido
        </h3>
        <p data-id="element-80">
          La guía es para tu uso personal y familiar. No está permitido
          redistribuir, revender, copiar ni compartir el contenido de forma
          pública o comercial sin autorización escrita.
        </p>

        <h3 className="font-bold text-[#1B2A4A] text-lg mt-2" data-id="element-81">
          5. Limitación de responsabilidad
        </h3>
        <p data-id="element-82">
          SOS Muela y sus creadores no se hacen responsables de decisiones
          médicas tomadas basándose en el contenido de esta guía. La información
          proporcionada es de carácter general y educativo. Siempre consulta con
          un profesional de salud dental para tu situación específica.
        </p>

        <h3 className="font-bold text-[#1B2A4A] text-lg mt-2" data-id="element-83">
          6. Propiedad intelectual
        </h3>
        <p data-id="element-84">
          Todo el contenido de SOS Muela — incluyendo texto, diseño, gráficos y
          estructura — está protegido por derechos de autor. Queda prohibida su
          reproducción sin autorización.
        </p>

        <h3 className="font-bold text-[#1B2A4A] text-lg mt-2" data-id="element-85">
          7. Modificaciones
        </h3>
        <p data-id="element-86">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios aplicarán a compras realizadas después de la
          fecha de actualización.
        </p>
      </LegalModal>
    </>;
}